export function readApiField(data: Record<string, unknown>, camel: string): unknown {
  if (camel in data) return data[camel];
  const pascal = camel.charAt(0).toUpperCase() + camel.slice(1);
  return data[pascal];
}

export function readApiString(data: Record<string, unknown>, camel: string, fallback = ''): string {
  const value = readApiField(data, camel);
  return value != null ? String(value) : fallback;
}

export function readApiBool(data: Record<string, unknown>, camel: string, defaultWhenMissing = true): boolean {
  const value = readApiField(data, camel);
  if (value === undefined || value === null) return defaultWhenMissing;
  return value !== false;
}

export function readApiNumber(data: Record<string, unknown>, camel: string, fallback: number): number {
  const value = readApiField(data, camel);
  if (value == null || value === '') return fallback;
  const num = Number(value);
  return Number.isFinite(num) ? num : fallback;
}

export function readApiNullableNumber(data: Record<string, unknown>, camel: string): number | null {
  const value = readApiField(data, camel);
  if (value == null || value === '') return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}
